import React from 'react'
import OfferHero from '../hero/offerHero'
import SlicesWrapper from '../slices/slicesWrapper'
import AnchorsContent from '../anchorsContent'
import PushContent from '../pushContent'
import SliderOffers from '../slices/sliderOffers'
import Challenges from '../offers/challenges'
import { useSelector } from 'react-redux'

import trads from '../../intl/trads.json'
import MapContacts from '../slices/mapContacts'

const OfferLayout = ({data, currentUrl, furtherContent}) => {
  const sectionsTitles = []
  const lang = useSelector(state => state.lang)

  data.slices && data.slices.forEach(slice => {
    const type = slice.internal ? slice.internal.type : slice.sys.contentType.sys.id

    if (type === 'ContentfulRates' || type === 'rates') {
      sectionsTitles.push(trads[lang].offers.rates)
    } else {
      slice = slice.fields ? slice.fields : slice
      sectionsTitles.push(slice.title ? slice.title : slice.anchorTitle ? slice.anchorTitle : '')
    }
  })

  return (
    <>
      <OfferHero 
        currentUrl={currentUrl}
        data={data} />

      <Challenges challenges={data.challenges} />

      { data.mapContacts &&
        <MapContacts data={data.mapContacts} />
      }

      <AnchorsContent  isOffer={true} sections={sectionsTitles}>
        <SlicesWrapper slices={data.slices} isOffer={true} />
      </AnchorsContent>

      <div className="mt-10 md:mt-20">
        <SliderOffers data={data.otherOffers} type="bottomPage" />
      </div>

      { ((furtherContent.nodes !== undefined && furtherContent.nodes.length > 0) || data.pushPages !== null) &&
        <PushContent data={data.pushPages} autoItems={furtherContent} />
      }
  </>
  )
}

export default OfferLayout